<template>
  <AbstractFilters :filters="filters"
                   :on-click="filter"
                   :selected-filter="postFilter"
  />
</template>
<script>

import config from '../../config'
import AbstractFilters from './AbstractFilters'

export default {
  name: 'CommunityPostFilters',
  components: { AbstractFilters },
  created() {
    this.$store.dispatch('setPostFilter', 'all')
  },
  methods: {
    filter(name) {
      this.$store.dispatch('setPostFilter', name)
    }
  },
  computed: {
    postFilter() {
      return this.$store.getters.postsFilter
    },
    filters() {
      return [
        { name: this.$t('filter.postFilters.all'), value: 'all' },
        { name: this.$t('filter.postFilters.fromMyCommunities'), value: 'myCommunities' },
        ...(config.ENABLE_DOCUMENT ? [{
          name: this.$t('filter.postFilters.postsWithAttachments'),
          value: 'attachments'
        }] : []),
        { name: this.$t('filter.postFilters.myPublishedPosts'), value: 'myPublished' },
        { name: this.$t('filter.postFilters.myBookmarkedPosts'), value: 'myBookmarks' }
      ]
    }
  }
}
</script>
